(function() {
    function bookingBoxPositionDefine() {
        if ($(".booking-box").length) {
            let box = $(".booking-box"),
                tLine = $(".rv-info__right-col-top-border"),
                bLine = $(".rv-info__right-col-bottom-border"),
                bLineOffset = bLine.offset().top,
                wS = $(window).scrollTop(),
                addTop = 40;
            if (
                wS >= tLine.offset().top - addTop &&
                wS < bLineOffset - box.outerHeight() - addTop
            ) {
                box.addClass("booking-box--fixed").removeClass("booking-box--absolute");
            } else if (
                wS >=
                bLineOffset - box.outerHeight() - addTop
            ) {
                box.removeClass("booking-box--fixed").addClass("booking-box--absolute");
            } else {
                box
                    .removeClass("booking-box--fixed")
                    .removeClass("booking-box--absolute");
            }
        }
    }
    $(function() {
        bookingBoxPositionDefine();
    });
    $(window).on("scroll orientationchange", function() {
        bookingBoxPositionDefine();
    });
    var resizeTimer;
    $(window).on("resize", function(e) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            // Run code here, resizing has "stopped"
            bookingBoxPositionDefine();
        }, 250);
    });
})();